import React from 'react';
import {
  Paper,
  Typography,
  Box,
  Card,
  CardContent,
  Divider
} from '@mui/material';
import { Work as WorkIcon } from '@mui/icons-material';

const ExperienceView = ({ experience = [] }) => {
  if (!experience || experience.length === 0) {
    return (
      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>Work Experience</Typography>
        <Typography variant="body2" color="text.secondary">
          No work experience added yet.
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>Work Experience</Typography>
      
      {experience.map((exp, index) => (
        <Box key={exp.id}>
          <Card sx={{ mb: 2 }}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                <WorkIcon color="primary" sx={{ mt: 0.5 }} />
                <Box sx={{ flex: 1 }}>
                  <Typography variant="h6">{exp.position}</Typography>
                  <Typography variant="subtitle1" color="text.secondary">
                    {exp.companyName}
                  </Typography>
                  {exp.location && (
                    <Typography variant="body2" color="text.secondary">
                      {exp.location}
                    </Typography>
                  )}
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    {exp.startDate} - {exp.current ? 'Present' : exp.endDate}
                  </Typography>
                  {exp.description && (
                    <Typography variant="body2" sx={{ mt: 1 }}>
                      {exp.description}
                    </Typography>
                  )}
                </Box>
              </Box>
            </CardContent>
          </Card>
          {index < experience.length - 1 && <Divider sx={{ my: 2 }} />}
        </Box>
      ))}
    </Paper>
  );
};

export default ExperienceView; 